import { Injectable } from '@angular/core';

import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorResponse } from '../model/error-response';
import { ErrorTitleEnum } from '../enum/error-title.enum';
import { PageService } from '../services/page.service';
import { StorageModule } from '../utils/storage.module';
import { MonitoringService } from '../services/monitoring.service';
import { urlConfig } from '../../../config/url.config';
import { ErrorService } from '../services/error.service';
import { SecurityService } from '../services/security/security.service';

const DEFAULT_SKIP_REDIRECT_ERRORS = [
  ErrorTitleEnum.STEP_TOKEN_INVALID ,
  ErrorTitleEnum.SECURITY_BIO_RETRY ,
  ErrorTitleEnum.SECURITY_EMAIL_INVALID ,
  ErrorTitleEnum.STEP_KIT_INVALID ,
  ErrorTitleEnum.STEP_KIT_CODE_INVALID ,
  ErrorTitleEnum.STEP_ACCOUNT_HOLDER ,
  ErrorTitleEnum.STEP_INVALID_CREDENTIONS ,
  ErrorTitleEnum.STEP_HAS_RESTRICTIVE ,
  ErrorTitleEnum.STEP_PROPOSAL_DENIED ,
  ErrorTitleEnum.SECURITY_PROPOSAL_DENIED,
]
@Injectable({
  providedIn: 'root'
})
export class AppInterceptorService implements HttpInterceptor {

  constructor(private pageService: PageService,
    private storage: StorageModule,
    private monitoringService: MonitoringService,
    private errorService: ErrorService,
    private securityService: SecurityService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipErrorRedirect = req.headers.has('x-error-redirect') ? req.headers.get('x-error-redirect') : 'no';
    let _request = req.clone({
      headers: req.headers.delete('x-error-redirect')
    });

    let isToEncryptDlb: boolean = this.isStepUrl(_request.url, _request.params);
    if (isToEncryptDlb && req.body) {
        _request = _request.clone({
            body: this.parseObjectRequestDlb(req.body),
        });
    }

    const isProposalURL = _request.url.indexOf('proposal/') > -1 ||
    _request.url.indexOf(urlConfig.url_api_identify) > -1 ||
    _request.url.indexOf(urlConfig.url_api_bff) > -1;
    const isLoadUrl = _request.url.indexOf('load') > -1;
    const isAddressURL = _request.url.indexOf('address/') > -1;

    if (!isProposalURL && !isAddressURL) {
      return next.handle(_request).pipe(
        map((response: HttpResponse<any>) => {
          return response;
        }),
        catchError((error: ErrorResponse) => {
          this.monitoringService.sendErroGA(error);
          this.errorService.add({ req, error });
          return throwError(error);
        }));
    }
    else {
      return next.handle(_request.clone({
        params: new HttpParams().append('gw-app-key', urlConfig.zup_app_key)
      },
      )).pipe(
        map((response: HttpResponse<any>) => {
          if (response instanceof HttpResponse) {
            if (response && response.body) {
              this.checkHsSatuts(response.body);
              this.extractToken(response);
              if (response.body.response) {
                response = response.clone({
                    body: JSON.parse(this.securityService.decryptAFE(response.body.response))
                })
              }
              return response;
            }

            return new HttpResponse({body:{}})
          }
        }),
        catchError((response: ErrorResponse) => {
          this
          this.extractToken(response);
          this.monitoringErro(response);
          this.monitoringService.sendErroGA(response);
          this.errorService.add({ _request, error: response });

          if (isProposalURL && !isAddressURL) {

            // check unauthorized request
            if (response.error && response.error.title) {
              if (DEFAULT_SKIP_REDIRECT_ERRORS.includes(response.error.title) ||
                skipErrorRedirect === 'skip') {
                return throwError(response);
              }
              else {
                const error = {...response.error, isLoadRequest: isLoadUrl }
                this.pageService.goToError({...response, error });
                return of(null)
              }
            }
            else{
              return throwError(response);
            }
          }
          else {
            return throwError(response);
          }
        })
      );
    }
  }

  private isStepUrl(url: string, params: HttpParams) {
    return (
        params.has('x-apply-dlb') &&
        url.includes(urlConfig.url_api_bff) &&
        !url.includes(urlConfig.url_api_identify) &&
        urlConfig.dlb_crypt === "sim"
    );
  }

  private parseObjectRequestDlb(body) {
    const stringifyBody = JSON.stringify(body);
    return {
        request: this.securityService.encryptAFE(stringifyBody),
    };
  }

  extractToken(response) {
    const reqXAccessToken = response.headers.has('x-access-token') ? response.headers.get('x-access-token') : false;
    this.storage.setAuthKey(reqXAccessToken);
  }

  monitoringErro(response) {
    const { message, name, ok, status, statusText, url } = response
    this.storage.setErro({
      message,
      name,
      ok,
      status,
      statusText,
      url
    });
  }

  checkHsSatuts(body) {
    if (body && body.nextStep == 'FINISH' && body.skip) {
      body.skip === 'B'
        ? this.monitoringService.show('pulo-hs-2')
        : this.monitoringService.show('pulo-hs-1');
    }
  }

}
